// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "backgroundVertexDeclaration";
const shader = `uniform mat4 view;uniform mat4 viewProjection;uniform float shadowLevel;#ifdef DIFFUSE
uniform mat4 diffuseMatrix;uniform vec2 vDiffuseInfos;#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;uniform float fFovMultiplier;#endif
#ifdef POINTSIZE
uniform float pointSize;#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @internal */
export const backgroundVertexDeclaration = { name, shader };
